import { Component, HostListener } from '@angular/core';
import { first } from 'rxjs';
import { ModelosService } from '../../services/modelos.service';

@Component({
  selector: 'app-mobile',
  standalone: false,
  templateUrl: './mobile.component.html',
  styleUrl: './mobile.component.css'
})
export class MobileComponent {
  menuPrincipal:boolean=false;
  isCollapsedPostVenta:boolean = false;
  modelos:any=[];
  
  constructor(private modelo: ModelosService) {
    this.isCollapsedPostVenta =false;
    this.modelo.getAll().pipe(first()).subscribe(
        (data:any) => {
         this.modelos = data.camiones;
        }
      );
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedInside = (event.target as HTMLElement).closest('.menu-principal');
    const clickedToggle = (event.target as HTMLElement).closest('.navbar-toggler');
    if (!clickedInside && !clickedToggle) {
      this.menuPrincipal = false;
    }
  }

  viewMenuPrincipal(): void {
    this.menuPrincipal = !this.menuPrincipal; // Alterna visibilidad del menú
  }

  noViewMenuPrincipal(): void {
    this.menuPrincipal = false; // Cierra el menú
  }
}
